var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 13,
    viewBox: "0 0 286 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999999 6.5L7.81035 3.88398C12.5492 2.0637 17.8621 2.52606 22.2152 5.13758L24.4134 6.45629C30.0282 9.82471 37.1035 9.55438 42.4449 5.76734L43.8227 4.79053C48.8417 1.23209 55.4236 0.761617 60.8976 3.57002L72.3296 9.43501C76.7282 11.6917 81.9068 11.8571 86.4405 9.88588L96.3333 5.58451C101.473 3.34991 107.395 3.87671 112.059 6.98337L114.669 8.72155C120.699 12.7377 128.656 12.2889 134.196 7.62017V7.62017C139.589 3.07565 147.293 2.51723 153.285 6.23665L155.086 7.35506C159.762 10.2579 165.578 10.638 170.592 8.36863L177.496 5.24393C183.235 2.6466 189.99 3.57499 194.846 7.5868V7.5868C200.497 12.2543 208.594 12.6737 214.66 8.56108L216.858 7.07081C222.296 3.38445 229.402 3.2746 234.95 6.79112L238.752 9.20062C244.7 12.97 252.384 12.5496 257.885 8.15401L260.699 5.90525C265.276 2.24766 271.45 1.29182 276.919 3.39397L285 6.5",
    stroke: "#E2DED5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomWave);
export default __webpack_public_path__ + "static/media/bottom_wave.e38e9a4ac5dcdb889db0f59448c37d73.svg";
export { ForwardRef as ReactComponent };